import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreateDeclarations = () => {
  return (
    <Create
      title="Създаване на декларация"
      mutationOptions={{ meta: { useFormData: true } }}
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};
export default CreateDeclarations;
